import { Button, Input, RadioGroup, Select } from '@attentive-platform/stem-ui';

import TrashIcon from '../../../Assets/TrashIcon';
import LoaderCircle from '../../LoaderCircle';
import CallbackHeadersTable from './CallbackHeadersTable';
import { ENTERPRISE_CALLBACK_EVENT_OPTIONS, ENTERPRISE_CALLBACK_VERBS } from '../callbackConstants';

const verbOptions = ENTERPRISE_CALLBACK_VERBS;

const eventOptions = ENTERPRISE_CALLBACK_EVENT_OPTIONS.map(ev => ({
  label: ev.label,
  value: ev.api
}));

const callbackRequireDataOptions = [
  { label: 'True', value: true },
  { label: 'False', value: false }
];

const CallbackCard = ({
  callback,
  index,
  savingId,
  deletingId,
  onUpdate,
  onDelete,
  onSave,
  onAddHeader,
  onUpdateHeader,
  onRemoveHeader
}) => {
  const handleCallbackRequireDataChange = (_, value) => {
    onUpdate(callback.localId, { callbackRequireData: value });
  };

  const isDeleting = deletingId === callback.localId;

  return (
    <div className='border border-gray-200 rounded-lg p-6 bg-white'>
      <div className='flex justify-between items-center mb-4 gap-4'>
        <Input
          value={callback.name}
          placeholder={`Callback ${index + 1}`}
          className='text-lg font-semibold flex-1 border-none'
          onChange={e => onUpdate(callback.localId, { name: e.target.value })}
        />
        {isDeleting ? (
          <LoaderCircle leftMargin={false} />
        ) : (
          <TrashIcon
            className='cursor-pointer text-red-500 hover:text-red-600 shrink-0'
            aria-label='Delete this callback'
            onClick={() => onDelete(callback)}
          />
        )}
      </div>

      <div className='grid gap-4 md:grid-cols-2 mb-4'>
        <div>
          <label className='text-sm font-medium text-gray-700 block mb-1'>Verb</label>
          <Select
            color='primary'
            variant='std-outlined'
            items={verbOptions}
            value={callback.verb}
            placeholder='Select value'
            onChange={value => onUpdate(callback.localId, { verb: value })}
            onClose={() => {}}
          />
        </div>
        <div>
          <label className='text-sm font-medium text-gray-700 block mb-1'>URL</label>
          <Input
            className='w-full'
            value={callback.url}
            placeholder='Enter URL'
            onChange={e => onUpdate(callback.localId, { url: e.target.value })}
          />
        </div>
      </div>

      <div className='mb-4'>
        <label className='text-sm font-medium text-gray-700 block mb-1'>Events</label>
        <Select
          multiple
          color='primary'
          variant='std-outlined'
          items={eventOptions}
          value={callback.events}
          placeholder='Select events'
          onChange={events => onUpdate(callback.localId, { events })}
          onClose={() => {}}
        />
      </div>

      <div className='pb-4 border-b border-gray-200 flex items-center justify-between'>
        <label className='text-sm font-medium text-gray-700'>Get data</label>
        <RadioGroup
          row
          variant='standard'
          value={callback.callbackRequireData ?? false}
          radioGroup={callbackRequireDataOptions}
          onChange={handleCallbackRequireDataChange}
        />
      </div>

      <CallbackHeadersTable
        headers={callback.headers}
        localId={callback.localId}
        onAddHeader={onAddHeader}
        onUpdateHeader={onUpdateHeader}
        onRemoveHeader={onRemoveHeader}
      />

      <div className='mt-6 flex justify-end'>
        <Button color='primary' onClick={() => onSave(callback)} loading={savingId === callback.localId}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default CallbackCard;
